import biRewardsApi from 'services/api/beautyInsider';
import UtilActions from 'utils/redux/Actions';
import { getContent } from 'services/api/Content/getContent';
import BeautyInsiderReducer from 'reducers/beautyInsider';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import store from 'store/Store';
import rougeExclusiveUtils from 'utils/rougeExclusive';
import helpers from 'utils/Helpers';

const isObject = helpers.isObject;
const { ACTION_TYPES: TYPES } = BeautyInsiderReducer;

const updateBIPersonalizedOffers = data => ({
    type: TYPES.SET_BI_PERSONALIZED_OFFERS,
    payload: data
});

function fetchBiRewards() {
    return async dispatch => {
        try {
            const data = await biRewardsApi.getBiRewardsGroupForSnapshot();
            const { basket } = store.getState();
            const updatedSkus = {
                ...data,
                biRewardGroups: {}
            };

            isObject(data?.biRewardGroups) &&
                Object.keys(data.biRewardGroups).length > 0 &&
                Object.keys(data.biRewardGroups).forEach(key => {
                    updatedSkus.biRewardGroups[key] = rougeExclusiveUtils.updateRougeExclusiveSkus(data.biRewardGroups[key], basket);
                });

            dispatch(UtilActions.merge('beautyInsider', 'biRewardGroups', updatedSkus.biRewardGroups));
        } catch (error) {
            dispatch(UtilActions.merge('beautyInsider', 'biRewardGroups', error));
        }
    };
}

async function getContentfulData(campaign, country, language) {
    const { data } = await getContent({
        language,
        country,
        path: `/advocacy/${campaign.campaignCode}`
    });

    if (!data?.excludeCountry) {
        campaign.content = data;
    }

    return campaign;
}

function getBeautyOffers(country, language) {
    return async dispatch => {
        try {
            const { data } = await getContent({
                language,
                country,
                path: '/beauty/beauty-offers/'
            });

            const { layout } = data;
            const offers = layout?.content.find(
                content =>
                    content.type === 'PromotionList' &&
                    Array.isArray(content.features) &&
                    content.features.some(feature => feature.handlerType === 'PromotionList_Personalized_For_You')
            );

            Storage.local.setItem(LOCAL_STORAGE.BI_OFFERS, offers);
            dispatch(UtilActions.merge('beautyInsider', 'biOffers', offers));
        } catch (error) {
            Sephora.logger.error('BeautyInsiderActions.getBeautyOffers error:', error);
        }
    };
}

function fetchClientSummary(includeCampaigns) {
    return async dispatch => {
        dispatch(UtilActions.merge('beautyInsider', 'summaryError', false));

        try {
            const summary = await biRewardsApi.getClientSummary(includeCampaigns);

            if (summary?.activeCampaigns?.length && Sephora.configurationSettings.isAdvocacyContentfulEnabled) {
                const { country, language } = Sephora.renderQueryParams;
                const activeCampaigns = await Promise.all(summary.activeCampaigns.map(campaign => getContentfulData(campaign, country, language)));

                dispatch(UtilActions.merge('beautyInsider', 'summary', { ...summary, activeCampaigns }));
            } else {
                dispatch(UtilActions.merge('beautyInsider', 'summary', summary));
            }
        } catch (error) {
            dispatch(UtilActions.merge('beautyInsider', 'summaryError', true));
            Sephora.logger.error('BeautyInsiderActions.fetchClientSummary error:', error);
        }
    };
}

export default {
    fetchBiRewards,
    fetchClientSummary,
    getBeautyOffers,
    updateBIPersonalizedOffers
};
